import { JsonUtils } from '../../utils/json.util'

export class ResponseMammogram {

    private _menos_de_um_ano: number | undefined
    private _mais_de_um_ano: number | undefined
    private _nunca_fiz: number | undefined

    get menos_de_um_ano(): number | undefined {
        return this._menos_de_um_ano
    }
    set menos_de_um_ano(value: number | undefined) {
        this._menos_de_um_ano = value
    }
    get mais_de_um_ano(): any | undefined {
        return this._mais_de_um_ano
    }
    set mais_de_um_ano(value: any | undefined) {
        this._mais_de_um_ano = value
    }
    get nunca_fiz(): any | undefined {
        return this._nunca_fiz
    }
    set nunca_fiz(value: any | undefined) {
        this._nunca_fiz = value
    }
    public fromJSON(json: any): ResponseMammogram{
        if (!json) {
            return this
        }
        if (typeof json === 'string') {
            if (!JsonUtils.isJsonString(json)) {
                return this
            }
            json = JSON.parse(json)
        }

        if (json.menos_de_um_ano !== undefined) {
            this.menos_de_um_ano = json.menos_de_um_ano
        }
        if (json.mais_de_um_ano !== undefined) {
            this.mais_de_um_ano = json.mais_de_um_ano
        }
        if (json.nunca_fiz !== undefined) {
            this.nunca_fiz = json.nunca_fiz
        }

        return this
    }
    public toJSON(): any {
        return {
            menos_de_um_ano: this.menos_de_um_ano || undefined,
            mais_de_um_ano: this.mais_de_um_ano || undefined,
            nunca_fiz: this.nunca_fiz || undefined,
        }
    }
}